export const menu = {
  paper: {
    maxHeight: 'none',
  },
  list: {
    margin: '-1.25rem -1rem',
  },
};
